<template>
    <div>
        <Row type="flex" justify="end" style="margin-bottom: 40px;">
            <i-col>
                <i-select filterable v-model="vendedor_id" clearable placeholder="Vendedores" @on-clear="() => vendedor_id = 0" style="width:200px;margin-left:7px;">
                        <Option v-for="saler in salers" :value="saler.value" :key="saler.value">{{ saler.label }}</Option>
                    </i-select>
            </i-col>
        </Row>
        <Spin size="large" fix v-if="loadingGraph"></Spin>
        <echart v-if="show_graphs" :options="graphs" style="width:100%" @click="getCustomersByMonthAndStatusActiveGraph" ref="ativos"></echart>
        <div v-show="showTable" class="tabela">
            <i-table ref="table" :columns="columns" :data="activeDataGraph"/>
            <Spin size="large" fix v-if="loadingTable"></Spin>
        </div>
    </div>

</template>

<script>
    import { moment } from '@/helpers/utils';
    import _ from 'lodash'
    import { revendaApi } from "@/api/axios";

    export default {
        components:{
            echart:()=>import("../../../components/charts/BarChart"),
            TableCvs: () => import("../../../components/table-csv/TableCsv")
        },
        props: {
            download: Boolean,
            refresh: Boolean,
            close: Boolean
        },
        data(){
            const tooltip = {
                    type:'shadow',
                    formatter:(params, ticket, callback)=>{
                        return `${params.name}: ${params.data.value} <br/> Receita: R$ ${this.formatMoney(params.data.profit)} <br/> Ticket Médio: R$ ${this.formatMoney(params.data.avgProfit)}`;
                    }
                }
            const yAxis = {
                value:'category'
            }

            return {
                scrollQuantityItems: 50,
                graphPeriodLength: 13,
                columns:[],
                statsPeriod: [],
                activeDataGraph:[],
                quantityDataColumns:[],
                quantityFooter:[],
                quantityData:[],
                months:["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
                salers:[],
                clients:[],
                status: '',
                period: '',
                loadingTable:false,
                loadingGraph: false,
                showTable:false,
                quantidade_cliente: 0,
                vendedor_id: 0,
                cliente_id: 0,
                filters:{
                    vendedorId:0,
                    vendedorNome: 'Vendedores',
                    mes:0,
                    chart:{
                        tipo:'',
                        mes:'',
                        monthName:'',
                        graphName:'',
                        quantidade_cliente: 0
                    }
                },
                graphs:{
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true,
                        show:false
                    },
                    xAxis : {},
                    yAxis : yAxis,
                    legend:{
                        data:["Novas Vendas", "Total"]
                    },
                    tooltip:tooltip,
                    series:[]
                },
                show_graphs:true
            }
        },

        methods: {
            async loadingData(){
                this.statsPeriod = this.last13Months();
                const period_table = this.statsPeriod.map(period => ({title:period.replace(/\d{2}/, "").replace(/\s+/, "/"), key: period, sortable: true}));
                this.quantityDataColumns = [
                    {
                        title: 'Estado',
                        key: 'estado',
                        sortable:true,
                        fixed:true
                    },
                    ...period_table
                ];

                this.columns = [
                    {
                        title:'#',
                        key:'vendedor_id',
                        sortable:true,
                        width: 100
                    },
                    {
                        title:'Vendedor',
                        key:'nome',
                        sortable:true,
                    },
                    {
                        title:'Nº de vendas',
                        key:'quantidade',
                        align: "center",
                        sortable:true,
                    },
                    {
                        title:'Ticket Médio',
                        key:'ticket_medio',
                        align: "right",
                        sortable:true,
                        render:(h, params)=>{
                            return h({
                                template:`<span>
                                        R$ ${this.formatMoney(params.row.ticket_medio)}
                                    </span>`
                            }
                            )
                        }
                    },
                    {
                        title:'Receita',
                        key:'receita',
                        align: "right",
                        sortable:true,
                        minWidth: 150,
                        render:(h, params)=>{
                            return h({
                                template:`<span>
                                        R$ ${this.formatMoney(params.row.receita)}
                                    </span>`
                            }
                            )
                        }
                    }
                ]
                this.getSalers();
                this.getClientsByRegions();
                await this.loadActiveGraph();
            },

            async getCustomersByMonthAndStatusActiveGraph (params) {
                const statusAlias = {"Novas Vendas": "newActives","Total":"total"};
                if (statusAlias[params.seriesName]) {
                    if (!params.selected) {
                        const period = params.data.period;
                        const status = statusAlias[params.seriesName];
                        this.period = period;
                        this.status = status;
                        this.quantidade_cliente = 0;
                        this.showTable = true;
                        this.loadingTable = true;
                        const data = await this.getGraphData(period, status, -1);
                        this.activeDataGraph = this.defaultingGraphData(data,period,status);
                        this.quantidade_cliente = params.value;
                        this.loadingTable = false;
                    } else {
                        this.showTable = false;
                    }
                }
            },

            defaultingGraphData (data,period,status) {
                let result = data
                result = _.uniqBy(result,'id_vendedor')
                result = result.map(value => (
                        {
                            vendedor_id: value.id_vendedor,
                            nome: value.vendedor_nome == null ?"Sem vendedor" : value.vendedor_nome,
                            mensalidade_valor: value.mensalidade_valor,
                            data_pagamento: value.data_lancamento,
                            quantidade: _.uniqBy(data.filter(item => {
                                if (item.id_vendedor == value.id_vendedor) {
                                    if(status=="totais"){
                                        return item
                                    }
                                    if(moment(period).month() +1 == moment(item.data_lancamento).month() +1){
                                        return item
                                    }
                                }
                            }),'id_pessoa').length,
                            receita: data.filter(item => {
                                if (item.id_vendedor == value.id_vendedor) {
                                    if(moment(period).month() +1 == moment(item.data_lancamento).month() +1){
                                        return item
                                    }
                                }
                            }).reduce( ( prevVal, elem ) => parseFloat(prevVal) + parseFloat(elem.mensalidade_valor), 0)
                        }
                    ))
                result = result.map(function(value){
                    value['ticket_medio'] = value.receita/value.quantidade
                    return value
                })
                return _.orderBy(result,['receita'],['desc']).filter(item => {
                    return item.quantidade > 0
                })
            },

            defaultingGraph(graphData) {
                let periods = [];
                for (let i=0; i <= this.graphPeriodLength; i++) {
                    periods.push({period: i, value: 0, profit: 0, avgProfit: 0});
                }
                graphData = graphData.map(period => ({period: period.periodo, value: parseFloat(period.total), profit: parseFloat(period.receita_bruta), avgProfit: parseFloat(period.ticket_medio)}));
                for (let i = 0; i <= periods.length ; i++) {
                    let dateMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                    dateMonth.setMonth(dateMonth.getMonth() - i);

                    let period = graphData.find(periodGraph => parseInt(periodGraph.period.split("-")[1] - 1) === dateMonth.getMonth() && parseInt(periodGraph.period.split("-")[0]) === dateMonth.getFullYear());
                    if (period) {
                        periods[i] = period;
                    }
                }
                return periods.reverse();
            },

            async getChart(status)
            {
                  const {data} = await revendaApi.get(`stats/companies/graph`, {
                    params: {
                        status, saler_id: this.vendedor_id
                    }
                });

                return data;
            },
            async loadActiveGraph (saler_id = 0) {
                let newActives = {};
                this.loadingGraph = true;
                newActives = await this.getChart("newActives");

                const total = await this.getChart("total");
                const newActivesData = this.defaultingGraph(newActives);
                this.graphs.xAxis = [
                    {
                        type : 'category',
                        data : this.statsPeriod,
                        axisLine: {onZero: true},
                        splitLine: {show: false},
                        splitArea: {show: false},
                    }
                ]
                this.graphs.series = [
                    {
                        name:'Novas Vendas',
                        type:'bar',
                        color:'#48D1CC',
                        stack:'clientes',
                        data:newActivesData,
                        label:{
                            normal:{
                                position:'top',
                                show:true,
                            }
                        }
                    },
                    {
                        name:'Total',
                        type:'line',
                        markLine:{
                            lineStyle:{
                                color:'#00FFFF'
                            }
                        },
                        label:{
                            normal:{
                                position:'top',
                                show:true
                            }
                        },
                        stack:'clientes',
                        data:this.defaultingGraph(total).map(periodo => ({value: periodo.value, profit: periodo.profit, avgProfit: periodo.avgProfit, period: periodo.period}))
                }
                ]
                this.loadingGraph = false;
            },

            graphTotalizer(firstData, secondData) {
                const totalizer = [];
                const collum1 = Object.values(firstData);
                const collum2 = Object.values(secondData);

                for (let i =0;i<=this.graphPeriodLength;i++) {
                    totalizer[i] = {value:collum1[i].value + collum2[i].value, profit:collum1[i].profit + collum2[i].profit, avgProfit:(collum1[i].avgProfit + collum2[i].avgProfit)/2}
                }
                return totalizer;
            },

            async getSalers() {
                const {data} = await revendaApi.get('saler/all');
                this.salers = [...data.map(vendedor => {return {label:vendedor.nome, value:vendedor.id_pessoa}})];
            },

            async getGraphData (period, status, page) {
                let url = "";
                if(status == "totais"){
                    return this.getGraphDataTotais(period, offset)
                }
                return await this.getChartData(period, status, page);
            },

            async getGraphDataTotais(period, page){
                let data = await this.getChartData(period, "actives", page);
                let data2 = await this.getChartData(period, "newActives", page);
                data = data.concat(data2)
                return data
            },

            async getChartData(period, status, page){
                const {data} = await revendaApi.get('stats/companies', {
                    params: {
                        status, page, period, saler_id: this.vendedor_id
                    }
                });
                return data
            },
            async getQuantityData () {
                const {data} = await revendaApi.get('stats/companies/states');
                return data;
            },

            last13Months() {
                const months = [];
                for (let i=this.graphPeriodLength; i>=0; i--) {
                    let dateMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                    dateMonth.setMonth(dateMonth.getMonth() - i);
                    months.push(`${this.months[dateMonth.getMonth()]} ${dateMonth.getFullYear()}`);
                }
                return months;
            },

            formatMoney( valor ) {
                valor = parseFloat(valor).toFixed(2).split('.');
                valor[0] = valor[0].split(/(?=(?:...)*$)/).join('.');
                return valor.join(',');
            },

            formatDataTableCompaniesByStates(data) {
                const states = new Set(data.flatMap(row => row.estado));
                const values = [];

                states.forEach(state => {
                    const row = {};
                    this.statsPeriod.forEach(period => {
                        row[period] = 0;
                    });
                    const periods = data.filter(period => period.estado === state).forEach(period => {
                        const periodInfo = period.periodo.split('-');
                        row[`${this.months[periodInfo[1] - 1]} ${periodInfo[0]}`] = period.total;
                    });
                    row.estado = state;
                    values.push(row);
                });

                const total = {};
                this.statsPeriod.forEach(period => {
                    total[period] =  _.sumBy(values, state => state[period]);
                });

                this.quantityFooter = total;
                this.quantityData = _.orderBy(values, [this.statsPeriod[this.statsPeriod.length - 1]], ['desc']);
            },

            async getClientsByRegions() {
                const companiesByStates = await this.getQuantityData();
                this.formatDataTableCompaniesByStates(companiesByStates);
            },

            exportData() {
                const dataCsv = [];
                this.activeDataGraph.forEach(row => {
                    const newRow = {};
                    this.columns.forEach((coluna, index) => {
                        if (row[coluna.key]) {
                            newRow[coluna.title] = row[coluna.key].toString().replace(/,/g, " ").replace(/\n+/, " ");
                        } else {
                            newRow[`Coluna ${index}`] = " ";
                        }
                    });
                    dataCsv.push(newRow);
                });

                this.$refs.table.exportCsv({
                    filename: "Efetividade revendedores ",
                    columns: this.columns
                })
            },
        },

        async created() {
            this.loadingData()
        },
        watch: {
            refresh(){
                if (this.refresh){
                    this.showTable = false
                    this.vendedor_id = 0
                    this.cliente_id = 0
                    this.loadingData()
                }
            },
            download(){
                if (this.download){
                    this.exportData()
                }
            },
            close(){
                if (this.close){
                    this.showTable = false
                    this.show_graphs = false
                } else {
                    this.show_graphs = true
                }
            },
            showTable(){
                this.$emit('download',this.showTable)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tabela {
        max-height: 400px;
        overflow: auto;
        position: relative;
    }
</style>
